// extracted by mini-css-extract-plugin
module.exports = {"alignGraphTitle":"GraphTitleSection_alignGraphTitle__1j5rm","leftSection":"GraphTitleSection_leftSection__lbRQK","rightSection":"GraphTitleSection_rightSection__3p8gm"};